import { useEffect } from 'react'
import { useFirmaContext } from '@/contexts/FirmaContext'

const ACK_KEY = 'autoPromote_ack_v1'

/**
 * One-shot Toast/Alert wenn der User für diese Firma automatisch zum Admin
 * promotet wurde. Acknowledged via localStorage, damit pro Firma nur einmal angezeigt.
 *
 * MVP nutzt window.alert() — Production sollte ein vorhandenes Toast/Modal-System
 * einsetzen sobald verfügbar.
 */
export function useAutoPromoteToast(firmaName: string | undefined) {
  const { autoPromoted } = useFirmaContext()

  useEffect(() => {
    if (!autoPromoted || !firmaName) return
    let acked: Record<string, true> = {}
    try {
      acked = JSON.parse(localStorage.getItem(ACK_KEY) ?? '{}')
    } catch {
      acked = {}
    }
    if (acked[firmaName]) return

    const timer = setTimeout(() => {
      window.alert(
        `Du wurdest automatisch als Admin-Ansprechpartner für ${firmaName} eingerichtet, ` +
        `da noch kein Admin hinterlegt war. Du kannst jetzt Co-Ansprechpartner einladen ` +
        `und ihre Berechtigungen verwalten.`
      )
      acked[firmaName] = true
      try {
        localStorage.setItem(ACK_KEY, JSON.stringify(acked))
      } catch {
        // ignore quota errors
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [autoPromoted, firmaName])
}
